import actions from './actions'

export default function WorkOrderTravelCostsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_WORKORDERTRAVELCOST:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_WORKORDERTRAVELCOST:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_WORKORDERTRAVELCOST:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_WORKORDERTRAVELCOST:
      return {
        ...state,
        editing: { WorkOrderTravelCostID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_WORKORDERTRAVELCOST_RECIEVED ||
      actions.UPDATE_WORKORDERTRAVELCOST_RECIEVED ||
      actions.DELETE_WORKORDERTRAVELCOST_RECIEVED:
      return {
        ...state,
        editing: { WorkOrderTravelCostID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
